import { RadioFormControlLabel, Typography } from "@kaltura/ds-react-components";
import { translate } from "@kaltura/ds-react-utils";
import { StyledRadioButtonsWrapper } from "./styledComponents";
import { useFormContext } from "react-hook-form";
import { CreateRoomFormValues, ScheduleOptions } from "../types";
import { ButtonClickAnalyticsType, FieldTypeOption } from "@kaltura/mediaspace-shared-types";
import { useButtonAnalytics } from "@kaltura/mediaspace-shared-hooks";
import { Schedule as SharedSchedule } from "@kaltura/mediaspace-shared-ui/form";

interface ScheduleProps {
    timezones: FieldTypeOption[];
}

/**
 * Schedule component provides room availability options
 */
const Schedule = (props: ScheduleProps) => {
    const { timezones } = props;
    const { register, watch } = useFormContext<CreateRoomFormValues>();
    const selectedRadioButton = watch("roomSchedulingType", ScheduleOptions.ALWAYS);

    const sendButtonAnalytics = useButtonAnalytics();

    const radioRegister = register(
        "roomSchedulingType",
        {
            onChange: (e) => {
                const isScheduled = e.target.value === ScheduleOptions.SCHEDULED;
                sendButtonAnalytics(
                    `Toggle Room availability - ${isScheduled ? "Schedule" : "Always"}`,
                    ButtonClickAnalyticsType.TOGGLE
                );
            },
        }
    );

    const isScheduled = selectedRadioButton === ScheduleOptions.SCHEDULED;

    return (
        <div>
            <Typography variant={"formLabel"} id="radio-buttons-group-label">
                {translate("Room availability")}
            </Typography>
            <StyledRadioButtonsWrapper
                aria-labelledby="radio-buttons-group-label"
                defaultValue={ScheduleOptions.ALWAYS}
                name="roomSchedulingType"
                addMargin={isScheduled}
            >
                <RadioFormControlLabel
                    label={translate("Always open")}
                    value={ScheduleOptions.ALWAYS}
                    checked={selectedRadioButton === ScheduleOptions.ALWAYS}
                    {...radioRegister}
                />
                <RadioFormControlLabel
                    label={translate("Specific time frame")}
                    value={ScheduleOptions.SCHEDULED}
                    checked={selectedRadioButton === ScheduleOptions.SCHEDULED}
                    {...radioRegister}
                />
            </StyledRadioButtonsWrapper>
            {isScheduled && <SharedSchedule timezones={timezones} />}
        </div>
    );
};

export default Schedule;
